module.exports = __webpack_public_path__ + "img/ic24Name1.bd822a3f.svg";